import { render } from "./NodeChatMessage.vue?vue&type=template&id=e962b79e"
import script from "./NodeChatMessage.vue?vue&type=script&lang=js"
export * from "./NodeChatMessage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NodeChatMessage.vue"]])

export default __exports__